import { DrawerProps } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button, ButtonGroup, SaveButton } from 'components/atoms/button';
import { Drawer } from 'components/atoms/drawer';
import {
  Title,
  TitleDescription,
  TitleWrapper,
} from 'components/organisms/module-settings/key-events-and-intervals/settings/styles';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: var(--spacing-07) var(--spacing-05);
  }
  .ant-drawer-header {
    background: var(--coolest-gray-10);
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

const StyledSaveButton = styled(SaveButton)`
  justify-content: space-between;
`;

type Props = DrawerProps & {
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
  refName: string;
};

export const KeyEventDrawer: React.FC<Props> = ({
  children,
  onSave,
  onCancel,
  isSaving,
  refName,
  ...rest
}) => {
  return (
    <StyledDrawer
      placement="right"
      width={360}
      destroyOnClose
      title={
        <TitleWrapper>
          <Title>
            <FormattedMessage id="key_event.create_key_event" />
          </Title>
          <TitleDescription>{refName}</TitleDescription>
        </TitleWrapper>
      }
      footer={
        <StyledButtonGroup>
          <Button onClick={onCancel}>
            <FormattedMessage id="cancel" />
          </Button>
          <StyledSaveButton onClick={onSave}>
            <FormattedMessage id="save" />
          </StyledSaveButton>
        </StyledButtonGroup>
      }
      {...rest}
    >
      {children}
    </StyledDrawer>
  );
};
